import { conf } from '../config/config';

/**
 * Checks if a given form has been configured to be fetched from the Claim Form API.
 *
 * @param formId - The unique identifier of the form.
 * @returns `true` if the API is enabled for the specified form, `false` otherwise.
 */
export const isFormApiEnabled = (formId: string): boolean => {
    return conf.apiEnabledForms.indexOf(formId) >= 0;
};
